<template>
  <div class="page">
    <div class="moneyLine">
      <div class="text" style="font-weight: bold">销售提成详情</div>
      <div v-if="$route.query.type !== 'refundStaffStatic'" class="text">
        当前业绩:¥{{ obj.realPerformance.money }}
      </div>
      <div v-if="$route.query.type !== 'refundStaffStatic'" class="text">
        提成金额:¥{{ obj.royaltyMoney.money }}
      </div>
      <div v-if="$route.query.type !== 'refundStaffStatic'" class="text">
        提成比例:{{ $public.cheng(obj.royaltyProportion.money, 100) }}%
      </div>
      <div v-if="$route.query.type === 'refundStaffStatic'" class="text">
        退款金额:{{ obj.returnPerformance.money }}
      </div>
      <el-button class="posi" size="mini" type="warning" @click="$router.back()"
        >返回</el-button
      >
    </div>
    <div class="orderLine">
      <div class="L">
        <div class="nav">
          <!-- saleStaffStatic 现金流水 -->
          <div
            class="navItem"
            v-if="
              type === 'saleStaffStatic' &&
              [1, 2, 3, 4, 5].indexOf(staffType) > -1
            "
            :class="curNavStr === 'goodsPerformance' ? 'active' : ''"
            @click="changeNav('goodsPerformance')"
          >
            商品订单
          </div>
          <div
            class="navItem"
            v-if="type === 'saleStaffStatic' && [1].indexOf(staffType) > -1"
            :class="curNavStr === 'medicalPerformance' ? 'active' : ''"
            @click="changeNav('medicalPerformance')"
          >
            医疗订单
          </div>
          <div
            class="navItem"
            v-if="
              type === 'saleStaffStatic' &&
              [1, 2, 3, 4, 5].indexOf(staffType) > -1
            "
            :class="curNavStr === 'huoTiPerformance' ? 'active' : ''"
            @click="changeNav('huoTiPerformance')"
          >
            活体订单
          </div>
          <!-- xiMeiStaffStatic 洗澡提成 -->
          <div
            class="navItem"
            v-if="type === 'xiMeiStaffStatic'"
            :class="curNavStr === 'xiMeiSalePerformance' ? 'active' : ''"
            @click="changeNav('xiMeiSalePerformance')"
          >
            洗澡订单
          </div>
          <div
            class="navItem"
            v-if="type === 'xiMeiStaffStatic'"
            :class="curNavStr === 'meiTuanPerformance' ? 'active' : ''"
            @click="changeNav('meiTuanPerformance')"
          >
            洗澡美团订单
          </div>
          <div
            class="navItem"
            v-if="type === 'xiMeiStaffStatic'"
            :class="
              curNavStr === 'consumerCardCancelPerformance' ? 'active' : ''
            "
            @click="changeNav('consumerCardCancelPerformance')"
          >
            洗澡卡核销订单
          </div>
          <!-- meiRongStaffStatic 美容提成 -->
          <div
            class="navItem"
            v-if="type === 'meiRongStaffStatic'"
            :class="curNavStr === 'meiRongSalePerformance' ? 'active' : ''"
            @click="changeNav('meiRongSalePerformance')"
          >
            美容订单
          </div>
          <div
            class="navItem"
            v-if="type === 'meiRongStaffStatic'"
            :class="curNavStr === 'meiRongMeiTuanPerformance' ? 'active' : ''"
            @click="changeNav('meiRongMeiTuanPerformance')"
          >
            美容美团订单
          </div>
          <div
            class="navItem"
            v-if="type === 'meiRongStaffStatic'"
            :class="
              curNavStr === 'meiRongConsumerCardCancelPerformance'
                ? 'active'
                : ''
            "
            @click="changeNav('meiRongConsumerCardCancelPerformance')"
          >
            美容卡核销订单
          </div>
          <!-- rechargeStaffStatic 充值业绩 -->
          <div
            class="navItem"
            v-if="type === 'rechargeStaffStatic'"
            :class="curNavStr === 'rechargePerformance' ? 'active' : ''"
            @click="changeNav('rechargePerformance')"
          >
            充值订单
          </div>
          <!-- virtualStaffStatic 综合提成 -->
          <div
            class="navItem"
            v-if="type === 'virtualStaffStatic'"
            :class="curNavStr === 'consumerCard' ? 'active' : ''"
            @click="changeNav('consumerCard')"
          >
            消费卡销售订单
          </div>
          <div
            class="navItem"
            v-if="type === 'virtualStaffStatic'"
            :class="
              curNavStr === 'medicalPackageServicePerformance' ? 'active' : ''
            "
            @click="changeNav('medicalPackageServicePerformance')"
          >
            套餐销售订单
          </div>
          <!-- jiYangStaffStatic 寄养提成 -->
          <div
            class="navItem"
            v-if="type === 'jiYangStaffStatic'"
            :class="curNavStr === 'jiYangPerformance' ? 'active' : ''"
            @click="changeNav('jiYangPerformance')"
          >
            寄养订单
          </div>
          <!-- followStaffStatic 跟诊提成 -->
          <div
            class="navItem"
            v-if="type === 'followStaffStatic'"
            :class="curNavStr === 'followPerformance' ? 'active' : ''"
            @click="changeNav('followPerformance')"
          >
            医疗订单
          </div>
          <div
            class="navItem"
            v-if="type === 'followStaffStatic'"
            :class="curNavStr === 'medicalPackageRoyalty' ? 'active' : ''"
            @click="changeNav('medicalPackageRoyalty')"
          >
            疫苗驱虫订单
          </div>
          <div
            class="navItem"
            v-if="type === 'followStaffStatic'"
            :class="curNavStr === 'medicalServiceRoyalty' ? 'active' : ''"
            @click="changeNav('medicalServiceRoyalty')"
          >
            医疗服务订单
          </div>
          <!-- subsidyStaffStatic 其它金额 -->
          <div
            class="navItem"
            v-if="
              type === 'subsidyStaffStatic' && [1, 2].indexOf(staffType) > -1
            "
            :class="curNavStr === 'yeZhenPerformance' ? 'active' : ''"
            @click="changeNav('yeZhenPerformance')"
          >
            夜诊
          </div>
          <div
            class="navItem"
            v-if="
              type === 'subsidyStaffStatic' && [1, 2].indexOf(staffType) > -1
            "
            :class="curNavStr === 'yeZhenHuLiPerformance' ? 'active' : ''"
            @click="changeNav('yeZhenHuLiPerformance')"
          >
            夜诊护理
          </div>
          <div
            class="navItem"
            :class="curNavStr === 'shuaYa' ? 'active' : ''"
            @click="changeNav('shuaYa')"
          >
            刷牙补助订单
          </div>
          <div
            class="navItem"
            v-if="
              type === 'subsidyStaffStatic' && [1, 2].indexOf(staffType) > -1
            "
            :class="curNavStr === 'subsidy' ? 'active' : ''"
            @click="changeNav('subsidy')"
          >
            DR补助订单
          </div>
          <div
            class="navItem"
            v-if="
              type === 'subsidyStaffStatic' && [1, 2].indexOf(staffType) > -1
            "
            :class="curNavStr === 'petBonus' ? 'active' : ''"
            @click="changeNav('petBonus')"
          >
            奖金
          </div>
          <!-- verificationStaffStatic 核销业绩 -->
          <div
            class="navItem"
            v-if="type === 'verificationStaffStatic'"
            :class="curNavStr === 'goodsYuEPerformance' ? 'active' : ''"
            @click="changeNav('goodsYuEPerformance')"
          >
            商品余额核销
          </div>
          <div
            class="navItem"
            v-if="
              type === 'verificationStaffStatic' && [1].indexOf(staffType) > -1
            "
            :class="curNavStr === 'caseYuEPerformance' ? 'active' : ''"
            @click="changeNav('caseYuEPerformance')"
          >
            病例余额核销
          </div>
          <div
            class="navItem"
            v-if="
              type === 'verificationStaffStatic' && [1].indexOf(staffType) > -1
            "
            :class="curNavStr === 'medicalPackageRoyalty' ? 'active' : ''"
            @click="changeNav('medicalPackageRoyalty')"
          >
            疫苗驱虫核销
          </div>
          <div
            class="navItem"
            v-if="
              type === 'verificationStaffStatic' && [1].indexOf(staffType) > -1
            "
            :class="curNavStr === 'medicalServiceRoyalty' ? 'active' : ''"
            @click="changeNav('medicalServiceRoyalty')"
          >
            医疗服务核销
          </div>
          <!-- refundStaffStatic 退货 -->
          <div
            class="navItem"
            v-if="type === 'refundStaffStatic'"
            :class="curNavStr === 'refundServicePerformance' ? 'active' : ''"
            @click="changeNav('refundServicePerformance')"
          >
            当月退款订单
          </div>
          <div
            class="navItem"
            v-if="type === 'refundStaffStatic'"
            :class="
              curNavStr === 'refundServiceLastPerformance' ? 'active' : ''
            "
            @click="changeNav('refundServiceLastPerformance')"
          >
            往月退款订单
          </div>
        </div>
        <div class="tabBox">
          <div class="tabTit">
            <div class="colTit" style="width: 120%">单号</div>
            <div class="colTit" style="width: 120%">类型</div>
            <div class="colTit">时间</div>
            <div
              v-if="$route.query.type !== 'refundStaffStatic'"
              class="colTit"
            >
              业绩金额
            </div>
            <div
              v-if="$route.query.type !== 'refundStaffStatic'"
              class="colTit"
            >
              提成金额
            </div>
            <div
              v-if="$route.query.type === 'refundStaffStatic'"
              class="colTit"
            >
              退款金额
            </div>
            <div class="colTit" style="width: 50%">操作</div>
          </div>
          <div
            v-if="orderList.length === 0"
            style="text-align: center; line-height: 400px"
          >
            无数据
          </div>
          <div v-else class="tabCon">
            <div
              class="tabItem"
              v-for="(item, index) in orderList"
              :key="index"
            >
              <div class="colItem" style="width: 120%">{{ item.no }}</div>
              <div class="colItem" style="width: 120%">{{ item.type }}</div>
              <div class="colItem">{{ item.dateTime }}</div>
              <div
                v-if="$route.query.type !== 'refundStaffStatic'"
                class="colItem"
              >
                {{ item.money.toFixed(2) }}
              </div>
              <div
                v-if="$route.query.type !== 'refundStaffStatic'"
                class="colItem"
                style="width: 70%"
              >
                {{ $public.cheng_1(item.money, obj.royaltyProportion.money) }}
              </div>
              <div
                v-if="$route.query.type === 'refundStaffStatic'"
                class="colItem"
                style="width: 70%"
              >
                {{ item.money.toFixed(2) }}
              </div>
              <div
                class="colItem"
                style="width: 50%; cursor: pointer; color: #f5882a"
                @click="
                  curOrderIndex = index;
                  getOrderDetail(item.no);
                "
              >
                查看
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="R">
        <div class="detail">
          <el-row>
            <el-col :span="8">
              <span class="label">订单编号：</span
              >{{ curOrderDetail.no || "--" }}
            </el-col>
            <el-col :span="8">
              <span class="label">顾客：</span
              >{{ curOrderDetail.nick_name || "--" }}
            </el-col>
            <el-col :span="8">
              <span class="label">电话：</span
              >{{ curOrderDetail.user_mobile || "--" }}
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <span class="label">订单类型：</span
              >{{ curOrderDetail.order_type || "--" }}
            </el-col>
            <el-col :span="8" v-if="curOrderDetail.no.split('_')[0] === 'CZ'">
              <span class="label">充值活动：</span
              >{{ curOrderDetail.rechargeActivity || "--" }}
            </el-col>
            <el-col :span="8">
              <span class="label">订单状态：</span
              >{{ curOrderDetail.state || "--" }}
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <span class="label">总计：</span>{{ curOrderDetail.total_price }}
            </el-col>
            <el-col :span="8">
              <span class="label">优惠券：</span
              >{{
                curOrderDetail.coupon_list[0]
                  ? curOrderDetail.coupon_list[0].name
                  : ""
              }}
            </el-col>
            <el-col
              :span="8"
              style="
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              "
            >
              <span class="label">订单备注：</span>
              <el-tooltip
                effect="dark"
                :content="curOrderDetail.orderRemark + ''"
                placement="left"
              >
                <span>{{ curOrderDetail.orderRemark }}</span>
              </el-tooltip>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <span class="label">创建人：</span
              >{{ curOrderDetail.create_manager_name }}
            </el-col>
            <el-col :span="8">
              <span class="label">创建时间：</span
              >{{ $public.FTime(curOrderDetail.create_time) }}
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <span class="label">结算方式：</span>
              <span
                style="padding-right: 30px"
                v-for="(item, index) in curOrderDetail.pay_info.pay_list"
                :key="index"
              >
                <span style="padding-right: 2px">
                  {{ $public.formatPayTypeState(item.pay_type) }}
                </span>
                {{ item.money }}
              </span>
            </el-col>
            <el-col :span="8">
              <span class="label">结算时间：</span
              >{{ $public.FTime(curOrderDetail.pay_info.pay_time) }}
            </el-col>
            <el-col
              :span="8"
              style="
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              "
            >
              <span class="label">结算备注：</span>
              <el-tooltip
                effect="dark"
                :content="curOrderDetail.pay_info.pay_remark + ''"
                placement="left"
              >
                <span>{{ curOrderDetail.pay_info.pay_remark }}</span>
              </el-tooltip>
            </el-col>
          </el-row>
        </div>
        <div class="tabBox">
          <div class="tabTit">
            <div class="colTit">商品名称</div>
            <div class="colTit">规格</div>
            <div
              v-if="$route.query.type !== 'refundStaffStatic'"
              class="colTit"
            >
              业绩金额
            </div>
            <div
              v-if="$route.query.type !== 'refundStaffStatic'"
              class="colTit"
            >
              提成金额
            </div>
            <div
              v-if="$route.query.type === 'refundStaffStatic'"
              class="colTit"
            >
              退款金额
            </div>
            <div class="colTit">销售人员</div>
          </div>
          <div
            v-if="orderList.length === 0"
            style="text-align: center; line-height: 400px"
          >
            无数据
          </div>
          <div v-else class="tabCon">
            <div
              class="tabItem"
              v-for="(item, index) in orderList[curOrderIndex]
                .staffStaticGoodsList"
              :key="index"
            >
              <div class="colItem">
                <el-tooltip
                  effect="dark"
                  :content="item.goodsName + ''"
                  placement="left"
                >
                  <span>{{ item.goodsName }}</span>
                </el-tooltip>
              </div>
              <div class="colItem">
                <el-tooltip
                  effect="dark"
                  :content="item.skuName + ''"
                  placement="left"
                >
                  <span>{{ item.skuName }}</span>
                </el-tooltip>
              </div>
              <div
                v-if="$route.query.type !== 'refundStaffStatic'"
                class="colItem"
              >
                {{ item.money }}
              </div>
              <div
                v-if="$route.query.type !== 'refundStaffStatic'"
                class="colItem"
              >
                {{ $public.cheng_1(item.money, obj.royaltyProportion.money) }}
              </div>
              <div
                v-if="$route.query.type === 'refundStaffStatic'"
                class="colItem"
              >
                {{ item.money }}
              </div>
              <div class="colItem">{{ item.saleNameList.join(",") }}</div>
            </div>
          </div>
          <div
            class="tabPosi"
            v-if="
              orderList.length > 0 &&
              !$public.isNull(orderList[curOrderIndex].staffStaticGoodsList)
            "
          >
            <div class="tabPosiL">
              共{{ orderList[curOrderIndex].staffStaticGoodsList.length }}件
            </div>
            <div class="tabPosiR">
              <span
                v-if="$route.query.type !== 'refundStaffStatic'"
                style="margin-right: 33px"
              >
                业绩金额：{{
                  orderList[curOrderIndex].staffStaticGoodsList.reduce(
                    (total, goods) => {
                      return $public.jia_1(total, goods.money);
                    },
                    0
                  )
                }}
              </span>
              <span
                v-if="$route.query.type !== 'refundStaffStatic'"
                style="margin-right: 33px"
              >
                提成比例：{{ obj.royaltyProportion.money * 100 }}%
              </span>
              <span v-if="$route.query.type !== 'refundStaffStatic'">
                提成金额：{{
                  orderList[curOrderIndex].staffStaticGoodsList.reduce(
                    (total, goods) => {
                      return $public.jia_1(
                        total,
                        $public.cheng_1(
                          goods.money,
                          obj.royaltyProportion.money
                        )
                      );
                    },
                    0
                  )
                }}
              </span>
              <span v-if="$route.query.type === 'refundStaffStatic'">
                退款金额：{{
                  orderList[curOrderIndex].staffStaticGoodsList.reduce(
                    (total, goods) => {
                      return $public.jia_1(
                        total,
                        $public.cheng_1(
                          goods.money,
                          obj.royaltyProportion.money
                        )
                      );
                    },
                    0
                  )
                }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      obj: {},
      type: this.$route.query.type,
      staffType: Number(this.$route.query.staffType),
      curNavStr: "",

      orderList: [],
      curOrderIndex: 0,
      curOrderDetail: {
        no: "",
        nick_name: "",
        user_mobile: "",
        order_type: "",
        state: "",
        total_price: "",
        coupon_list: "",
        orderRemark: "",
        create_manager_name: "",
        create_time: "",
        pay_info: {
          pay_list: [],
        },
        rechargeActivity: "", // 充值活动
      },
    };
  },
  created() {
    this.obj = JSON.parse(sessionStorage.getItem("shuju_staffOrderList"));
  },
  mounted() {
    if (this.type === "saleStaffStatic") {
      this.curNavStr = "goodsPerformance";
    } else if (this.type === "xiMeiStaffStatic") {
      this.curNavStr = "xiMeiSalePerformance";
    } else if (this.type === "meiRongStaffStatic") {
      this.curNavStr = "meiRongSalePerformance";
    } else if (this.type === "rechargeStaffStatic") {
      this.curNavStr = "rechargePerformance";
    } else if (this.type === "virtualStaffStatic") {
      this.curNavStr = "consumerCard";
    } else if (this.type === "verificationStaffStatic") {
      this.curNavStr = "goodsYuEPerformance";
    } else if (this.type === "jiYangStaffStatic") {
      this.curNavStr = "jiYangPerformance";
    } else if (this.type === "yeZhenStaffStatic") {
      this.curNavStr = "yeZhenPerformance";
    } else if (this.type === "yeZhenHuLiStaffStatic") {
      this.curNavStr = "yeZhenHuLiPerformance";
    } else if (this.type === "followStaffStatic") {
      this.curNavStr = "followPerformance";
    } else if (this.type === "subsidyStaffStatic") {
      this.curNavStr = "shuaYa";
    } else if (this.type === "petBonus") {
      this.curNavStr = "petBonus";
    }else if (this.type === "refundStaffStatic") {
      this.curNavStr = "refundServicePerformance";
    }

    this.orderList = this.obj[this.curNavStr].orderList;
    if (this.orderList.length > 0) {
      this.getOrderDetail(this.orderList[0].no);
    }
  },
  methods: {
    changeNav(str) {
      this.curOrderIndex = 0;
      this.curOrderDetail = {
        no: "",
        nick_name: "",
        user_mobile: "",
        order_type: "",
        state: "",
        total_price: "",
        coupon_list: "",
        orderRemark: "",
        create_manager_name: "",
        create_time: "",
        pay_info: {
          pay_list: [],
        },
        rechargeActivity: "", // 充值活动
      };
      this.curNavStr = str;
      this.orderList = this.obj[this.curNavStr].orderList;
      if (this.orderList.length > 0) {
        this.getOrderDetail(this.orderList[0].no);
      }
    },
    getOrderDetail(no) {
      if (
        this.curNavStr === "medicalPackageRoyalty" ||
        this.curNavStr === "medicalServiceRoyalty"
      ) {
        return;
      }
      let s = no.split("_")[0];
      let loading = this.$loading();
      if (s === "CZ") {
        // 充值
        let params = {
          orderid: no,
        };
        this.$http.get("/api/Recharge/GetRecharge", params).then((res) => {
          loading.close();
          if (res.code == 0) {
            let d = res.data;
            this.curOrderDetail.no = d.no;
            this.curOrderDetail.nick_name = d.user_info.nick_name;
            this.curOrderDetail.user_mobile = d.user_info.user_mobile;
            this.curOrderDetail.order_type = "充值";
            this.curOrderDetail.state = this.$public.formatOrderState(d.state);
            this.curOrderDetail.total_price = d.price;
            this.curOrderDetail.coupon_list = [];
            this.curOrderDetail.orderRemark = d.remark;
            this.curOrderDetail.create_manager_name = d.create_manager_name;
            this.curOrderDetail.create_time = d.create_time;
            this.curOrderDetail.pay_info = d.pay_info;
            this.curOrderDetail.rechargeActivity =
              d.activity_info.activity_name;
          }
        });
      } else if (s === "TK" || s === "TH" || s === "TCZ") {
        // 退换 退款
        let params = {
          orderNumber: no,
        };
        this.$http.get("/api/ReturnOrder/Detail", params).then((res) => {
          loading.close();
          if (res.code == 0) {
            let d = res.data;
            this.curOrderDetail.no = d.no;
            this.curOrderDetail.nick_name = d.user_info.nick_name;
            this.curOrderDetail.user_mobile = d.user_info.user_mobile;
            this.curOrderDetail.order_type = "退款";
            this.curOrderDetail.state = this.$public.formatOrderReturnState(
              d.state
            );
            this.curOrderDetail.total_price = d.total_price;
            this.curOrderDetail.coupon_list = d.coupon_list;
            this.curOrderDetail.orderRemark = d.remark;
            this.curOrderDetail.create_manager_name = d.create_user_name;
            this.curOrderDetail.create_time = d.create_time;
            this.curOrderDetail.pay_info = d.pay_info;
          }
        });
      } else {
        ///////////////////////////////////////
        let params = {
          orderid: no,
        };
        this.$http.get("/api/Order/GetOrder", params).then((res) => {
          loading.close();
          if (res.code == 0) {
            let d = res.data;
            this.curOrderDetail.no = d.no;
            this.curOrderDetail.nick_name = d.user_info.nick_name;
            this.curOrderDetail.user_mobile = d.user_info.user_mobile;
            this.curOrderDetail.order_type = d.order_type;
            this.curOrderDetail.state = this.$public.formatOrderState(d.state);
            this.curOrderDetail.total_price = d.total_price;
            this.curOrderDetail.coupon_list = d.coupon_list;
            this.curOrderDetail.orderRemark = d.remark;
            this.curOrderDetail.create_manager_name = d.create_manager_name;
            this.curOrderDetail.create_time = d.create_time;
            this.curOrderDetail.pay_info = d.pay_info;
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.page {
  height: 100%;
  .moneyLine {
    background-color: #fff;
    display: flex;
    height: 52px;
    background-color: #fff;
    line-height: 52px;
    padding: 0 15px;
    position: relative;
    .text {
      font-size: 14px;
      color: #333;
      margin-right: 50px;
    }
    .posi {
      position: absolute;
      right: 10px;
      top: 12px;
    }
  }
  .orderLine {
    margin-top: 5px;
    display: flex;
    height: calc(100% - 57px);
    .L {
      width: 607px;
      margin-right: 10px;
      flex-shrink: 0;
      height: 100%;
      .nav {
        display: flex;
        background-color: #fff;
        margin-bottom: 5px;
        .navItem {
          font-size: 14px;
          color: #333333;
          box-sizing: border-box;
          margin: 0 20px;
          line-height: 44px;
          cursor: pointer;
          &.active {
            border-bottom: 2px solid $mainColor;
          }
        }
      }
      .tabBox {
        padding-bottom: 10px;
        background-color: #fff;
        height: calc(100% - 51px);
        box-sizing: border-box;
        .tabTit {
          background-color: $tableTitBg;
          display: flex;
          height: 44px;
          color: #333333;
          position: relative;
          justify-content: space-around;
          .colTit {
            line-height: 44px;
            padding: 0 10px;
            font-size: 14px;
            width: 100%;
          }
          .see {
            position: absolute;
            right: 0px;
            padding-right: 20px;
            color: #467eff;
            flex-grow: 0;
            cursor: pointer;
          }
        }
        .tabCon {
          height: calc(100% - 50px);
          overflow: auto;
          .tabItem {
            background-color: #fff;
            display: flex;
            height: 44px;
            border-bottom: 1px solid #f2f2f2;
            color: #333333;
            justify-content: space-around;
            .colItem {
              line-height: 44px;
              padding: 0 10px;
              font-size: 12px;
              width: 100%;
            }
          }
        }
      }
    }
    .R {
      width: 100%;
      height: 100%;
      .detail {
        padding: 10px;
        background-color: #fff;
        font-size: 12px;
        color: #666;
        line-height: 35px;
        width: 100%;
        box-sizing: border-box;
        .label {
          display: inline-block;
          width: 60px;
          text-align: right;
        }
      }
      .tabBox {
        padding-bottom: 46px;
        background-color: #fff;
        width: 100%;
        height: calc(100% - 194px);
        box-sizing: border-box;
        position: relative;
        .tabTit {
          background-color: $tableTitBg;
          display: flex;
          height: 44px;
          color: #333333;
          position: relative;
          justify-content: space-around;
          padding: 0 10px;
          .colTit {
            line-height: 44px;
            font-size: 14px;
            width: 100%;
          }
          .see {
            position: absolute;
            right: 0px;
            padding-right: 20px;
            color: #467eff;
            flex-grow: 0;
            cursor: pointer;
          }
        }
        .tabCon {
          height: calc(100% - 44px);
          overflow: auto;
          .tabItem {
            background-color: #fff;
            display: flex;
            height: 44px;
            border-bottom: 1px solid #f2f2f2;
            color: #333333;
            justify-content: space-around;
            padding: 0 10px;
            .colItem {
              line-height: 44px;
              font-size: 12px;
              width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
        .tabPosi {
          position: absolute;
          display: flex;
          justify-content: space-between;
          width: 100%;
          padding: 0 12px;
          line-height: 44px;
          font-size: 14px;
          color: #333;
          box-sizing: border-box;
          box-shadow: 0px -1px 5px 0px rgba(211, 233, 255, 0.65);
          .tabPosiL {
          }
          .tabPosiR {
          }
        }
      }
    }
  }
}
</style>
